import i18next from 'i18next';

import { CONFIG } from 'src/global-config';

export function buildSupportMailtoUrl(): string {
  const email = CONFIG.supportEmail;
  const subject = encodeURIComponent(
    i18next.t('errors.serverError.email.subject', { ns: 'common' })
  );
  const body = encodeURIComponent(i18next.t('errors.serverError.email.body', { ns: 'common' }));
  return `mailto:${email}?subject=${subject}&body=${body}`;
}
